class IObserver {

  constructor(node) {

    if (node.nodeType !== Node.ELEMENT_NODE) return;
    this.root = node;
    this._load();

  }

  _load() {

    this.intersectionObserver = new IntersectionObserver(
      this._handleIntersect,
      {
        root: null,
        rootMargin: '0px',
        threshold: 0
      }
    );

    this.intersectionObserver.USE_MUTATION_OBSERVER = false;
    this.intersectionObserver.observe(this.root)

  }

  _handleIntersect(entries, observer) {

    entries.forEach(entry => {

      if (entry.isIntersecting) {
        setTimeout(() => entry.target.classList.add('u-viewed'), 500);
        observer.unobserve(entry.target);
      }

    });

  }

}

[...document.querySelectorAll('.js-iobserver')].forEach(
  section => (new IObserver(section))
);
